export class AdminMenuItem {

  constructor(
    public readonly title: string,
    public readonly iconPath: string,
    public readonly navigateTo: string,
    public readonly slug: string, // must be unique
    private active?: boolean
  ) {
    if (this.active === undefined) this.active = false;
  }

  public setNotActive() {
    this.active = false;
  }

  public setActive() {
    this.active = true;
  }

  public isActive() {
    return this.active;
  }
}